import MainLayout from '@components/Shared/Layout';
import { ROUTE_PATHS } from '@constants/routes';
import HomePage from '@pages/Home';
import LoginPage from '@pages/Login';
import ProjectOverviewPage from '@pages/ProjectOverview';
import ProjectsPage from '@pages/Projects';
import ServerConfigPage from '@pages/ServerConfig';
import SettingsPage from '@pages/Settings';
import UsersPage from '@pages/Users';
import ViewerPage from '@pages/Viewer';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path={ROUTE_PATHS.LOGIN} element={<LoginPage />} />

        <Route element={<MainLayout />}>
          <Route path={ROUTE_PATHS.HOME} element={<HomePage />} />

          <Route path={ROUTE_PATHS.FOLDERS} element={<ProjectsPage />} >
            <Route index element={null} />
            <Route path={ROUTE_PATHS.FOLDER} element={null} />
          </Route>

          <Route path={ROUTE_PATHS.PROJECTS} element={<ProjectsPage />} />

          <Route path={ROUTE_PATHS.PROJECT} element={<ProjectOverviewPage />} >
            <Route index element={null} />
            <Route path={ROUTE_PATHS.PROJECT_INSPECTIONS} element={null} />
            <Route path={ROUTE_PATHS.PROJECT_CHECKLISTS} element={null} />
            <Route path={ROUTE_PATHS.PROJECT_INSPECTION_POI_STEP} element={null} />
          </Route>

          <Route path={ROUTE_PATHS.USERS} element={<UsersPage />} />
          <Route path={ROUTE_PATHS.SETTINGS} element={<SettingsPage />} />
          <Route path={ROUTE_PATHS.SERVER_CONFIG} element={<ServerConfigPage />} />
        </Route>

        <Route path={ROUTE_PATHS.VIEWER_PROJECT} element={<ViewerPage />} >
          <Route index element={null} />
          <Route path={ROUTE_PATHS.VIEWER_PROJECT_INSPECTION} element={null} />
          <Route path={ROUTE_PATHS.VIEWER_PROJECT_INSPECTION_POI_STEP} element={null} />
        </Route>

        <Route path={ROUTE_PATHS.NOT_FOUND} element={<Navigate to={ROUTE_PATHS.HOME} />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
